import {MagnificPopup} from "../dynamic-imports/MagnificPopup";
import {region} from "../others/Configuration";
import PopinKoboRedirectTemplate from "./PopinKoboRedirect.mustache"

// Used only for ES and PT
export default class extends MagnificPopup{
  constructor({ el }) {
    super(el, {
      items: {
        src: PopinKoboRedirectTemplate.render({url: el.href ? el.href : el.dataset.url, withLogo: region === "ES"}),
        showCloseBtn: true
      }
    });
  }
}



